// Matches the existing ASP.NET Identity default password policy in this API.
// Login deliberately does not use these new-account checks (legacy passwords exist).
const passwordChecks=[
 ['authPasswordLength',value=>value.length>=6],
 ['authPasswordUpper',value=>/[A-Z]/.test(value)],
 ['authPasswordLower',value=>/[a-z]/.test(value)],
 ['authPasswordDigit',value=>/[0-9]/.test(value)],
 ['authPasswordSymbol',value=>/[^a-zA-Z0-9]/.test(value)]
];
export function registrationPasswordErrors(value,t){
 return passwordChecks.filter(([,valid])=>!valid(String(value||''))).map(([key])=>t(key));
}

const identityFields={
 duplicateemail:['email','emailExists'],invalidemail:['email','authInvalidEmail'],
 passwordtooshort:['password','authPasswordLength'],
 passwordrequiresupper:['password','authPasswordUpper'],
 passwordrequireslower:['password','authPasswordLower'],
 passwordrequiresdigit:['password','authPasswordDigit'],
 passwordrequiresnonalphanumeric:['password','authPasswordSymbol']
};
const fieldNames={adi:'adi',soyadi:'soyadi',email:'email',password:'password',confirm:'confirm'};
const fieldOrder=['adi','soyadi','email','password','confirm'];

// Identity errors may be an array OR ReferenceHandler.Preserve's {$values:[...]}.
// Also accept ModelState / ValidationProblemDetails, but never render server text.
export function registrationFieldErrors(data,text,t,status=400){
 if(![400,409,422].includes(status))return {};
 const found={};let visited=0;
 const add=(field,key)=>{const values=found[field]||(found[field]=[]),message=t(key);if(!values.includes(message))values.push(message);};
 function visit(value,field='',depth=0){
  if(depth>8||++visited>200||value==null)return;
  if(Array.isArray(value)){value.forEach(item=>visit(item,field,depth+1));return;}
  if(typeof value==='string'){
   const code=identityFields[value.toLowerCase()];
   if(code){add(...code);return;}
   if(/e-posta.*kayıtlı/iu.test(value)){add('email','emailExists');return;}
   if(field){
    const required=/\brequired\b|zorunlu|gerekli/iu.test(value);
    add(field,required?'authRequired':field==='email'?'authInvalidEmail':field==='password'?'authPasswordRejected':'authFieldRejected');
   }
   return;
  }
  if(typeof value!=='object')return;
  const code=String(value.code||value.Code||'').toLowerCase(),known=identityFields[code];
  if(known){add(...known);return;}
  if(code.startsWith('password')){add('password','authPasswordRejected');return;}
  for(const [key,item] of Object.entries(value)){
   if(['$id','$ref','code','Code','title','status','traceId','type','instance'].includes(key))continue;
   const name=fieldNames[key.split('.').at(-1).toLowerCase()];
   if(name||['$values','errors','Errors','message','Message'].includes(key))visit(item,name||field,depth+1);
  }
 }
 visit(data);
 // Legacy duplicate-email response is plain text (sometimes JSON-quoted).
 if(typeof data!=='object'||data===null)visit(text);
 return Object.fromEntries(fieldOrder.filter(key=>found[key]?.length).map(key=>[key,found[key]]));
}
